import { render, staticRenderFns } from "./TextTemplates.vue?vue&type=template&id=5db9f841&scoped=true"
import script from "./TextTemplates.vue?vue&type=script&lang=js"
export * from "./TextTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9f841",
  null
  
)

export default component.exports